const header = document.querySelector('.o-header')
const searchPanel = header.querySelector('#views-exposed-form-search-page-1')
const input = searchPanel.querySelector('input[type="text"]')
const button = searchPanel.querySelector('input[type="submit"]')

document.addEventListener('click', (e) => {
  if (e.target.closest('.open-search')) {
    header.classList.toggle('search-open')
    if (header.classList.contains('search-open')) {
      input.select()
    }
  }
})

button.addEventListener('click', (e) => {
  header.classList.toggle('search-open')
})
